export default "__VITE_ASSET__Cepm0cod__"